import { AppStatusBadge } from '@/components/AppStatusBadge/AppStatusBadge'
import { Dac7Dialog } from '@/components/Dac7Infos/Dac7Dialog'
import { ErrorNetworkHandler } from '@/components/Error/ErrorNetworkHandler/ErrorNetworkHandler'
import { NetworkBadge } from '@/components/NetworkBadge/NetworkBadge'
import { SellerConsentDialog } from '@/components/SellerConsent/SellerConsentDialog'
import { StripeAutoDebitAgreementModal } from '@/components/Stripe/StripeAutoDebitAgreement/StripeAutoDebitAgreementModal/StripeAutoDebitAgreementModal'
import { StripeTermsOfServicesModal } from '@/components/Stripe/StripeTermsOfServicesModal/StripeTermsOfServicesModal'
import { NotificationContainer } from '@/components/ui/Notification/Notification'

import type { ReactNode } from 'react'

type LayoutProviderProps = {
  children: ReactNode
}

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  return (
    <>
      <AppStatusBadge />
      <div className="app-wrapper">
        {children}
        <NotificationContainer />
        <ErrorNetworkHandler />
        <NetworkBadge />
        <StripeTermsOfServicesModal />
        <StripeAutoDebitAgreementModal />
        <SellerConsentDialog />
        <Dac7Dialog />
      </div>
    </>
  )
}
